import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NoItemsSize } from '@app/shared/components/no-items/no-items.component';

import { NotificationType } from '@app/shared/interfaces/lib/notification.interface';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { DirectService, PayoutMethod } from '../../services/direct.service';

@Component({
  standalone: false,
  templateUrl: './earnings-reports.component.html',
  styleUrls: ['./earnings-reports.component.scss'],
})
export class EarningsReportsComponent implements OnInit {
  NoItemsSize = NoItemsSize;

  loadingPayoutMethods: boolean;
  payoutMethods: PayoutMethod[];
  taxYear = 2024;

  constructor(
    private readonly direct: DirectService,
    private readonly router: Router,
    private toast: ToastNotificationsService
  ) {}

  ngOnInit(): void {
    this.getPayoutMethods();
  }

  has1099KForms(): boolean {
    return this.payoutMethods?.some(method => method.forms_1099k?.includes(this.taxYear)) ?? false;
  }

  getPayoutMethods() {
    this.loadingPayoutMethods = true;
    this.direct.getPayoutMethods().subscribe((res: PayoutMethod[]) => {
      this.loadingPayoutMethods = false;
      this.payoutMethods = res;
    });
  }

  generateEarningReport(type: 'pdf' | 'csv', payoutMethodUuid?: string) {
    this.direct.generateEarningReport(type, payoutMethodUuid).subscribe(
      (response: any) => {
        // Get filename from content-disposition header
        const contentDisposition = response.headers?.get('content-disposition');
        let filename = `report.${type}`;

        if (contentDisposition?.includes('filename=')) {
          filename = contentDisposition.split('filename="')[1].replace('"', '');
        }

        const blob = new Blob([response.body], {
          type: type === 'pdf' ? 'application/pdf' : 'text/csv'
        });
        const url = URL.createObjectURL(blob);

        // Open in new tab with correct filename
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        URL.revokeObjectURL(url);
      },
      (error) => {
        this.toast.open('Error downloading report', 'Dismiss', NotificationType.Error);
      }
    );
  }

  download1099K(payoutMethodUuid: string) {
    // TODO: we should absolutely make this dynamic for next year.
    const taxYear = 2024;
    this.direct.download1099K(payoutMethodUuid, taxYear).subscribe(
      (response: any) => {
        // Get filename from content-disposition header
        const contentDisposition = response.headers?.get('content-disposition');
        let filename = `1099k-${taxYear}.pdf`;

        if (contentDisposition?.includes('filename=')) {
          filename = contentDisposition.split('filename="')[1].replace('"', '');
        }

        const blob = new Blob([response.body], {
          type: 'application/pdf'
        });
        const url = URL.createObjectURL(blob);

        // Open in new tab with correct filename
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        URL.revokeObjectURL(url);
      },
      (error) => {
        this.toast.open('Error downloading 1099-K form', 'Dismiss', NotificationType.Error);
      }
    );
  }
}
